export default {"src":"/_next/static/media/female-profile.19ca1e74.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};